import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CarrierRead } from '@ragu-components/ord-types';

const CarriersList = React.lazy(async () => import('./CarriersList'));

export const carriersResources: OrdResourceProps = {
  key: Resources.carriers,
  name: Resources.carriers,
  list: <CarriersList />,
  options: {},
  recordRepresentation: (record: CarrierRead) => record.name,
};
